import React, { useEffect, useState } from "react";
import { Card, Row, Col, Modal, Button, Form } from "react-bootstrap"
import { currencyFormat } from "../../../helpers/numericFields";


export const PaymentDetails = ({ payment, isOpen, setIsOpen }) => {

  return (
    <Modal
      size="lg"
      show={isOpen}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      <Modal.Header>
        <Modal.Title >
          Pago Agendado
        </Modal.Title>
        <Button
          onClick={() => setIsOpen(false)}
          className="btn-close"
          variant=""
        >
          x
        </Button>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col md={12}>
            <Card>
              <Card.Header>
                <h3 className="card-title">
                  Detalles
                </h3>
              </Card.Header>
              <Card.Body>
                <Form>
                  <Form.Group as={Row} className="mb-3">
                    <Form.Label column sm="2">
                      Concepto:
                    </Form.Label>
                    <Col sm="10" className="d-flex">
                      <Form.Control plaintext readOnly defaultValue={payment.concept} />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3">
                    <Form.Label column sm="2">
                      Descripcion:
                    </Form.Label>
                    <Col sm="10" className="d-flex">
                      <Form.Control plaintext readOnly defaultValue={payment.description} />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3">
                    <Form.Label column sm="2">
                      Monto:
                    </Form.Label>
                    <Col sm="10" className="d-flex">
                      <Form.Control plaintext readOnly defaultValue={currencyFormat(payment.amount || 0)} />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3">
                    <Form.Label column sm="2">
                      Fecha:
                    </Form.Label>
                    <Col sm="10" className="d-flex">
                      <Form.Control plaintext readOnly defaultValue={payment.date} />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3">
                    <Form.Label column sm="2">
                      Notas:
                    </Form.Label>
                    <Col sm="10" className="d-flex">
                      <Form.Control plaintext readOnly defaultValue={payment.notes} />
                    </Col>
                  </Form.Group>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}
